(function () {
  function initLinkEffects(root = document) {
    const els = root.querySelectorAll('.link-effect:not([data-effect-ready])');
    els.forEach(el => {
      el.setAttribute('data-effect-ready', 'true');

      const original = el.innerHTML.trim();

      // Container — isolated hover scope via named group
      el.classList.add(
        'relative','inline-flex','overflow-hidden','align-middle', 'group/linkfx'
      );

      // FRONT (visible → slide up + fade out)
      const front = document.createElement('span');
      front.className = [
        'pointer-events-none','whitespace-nowrap',
        'transition-all','duration-300','ease-out',
        'opacity-100','translate-y-0',
        'group-hover/linkfx:-translate-y-full','group-hover/linkfx:opacity-0'
      ].join(' ');
      front.innerHTML = original;

      // BACK (hidden → slide in + fade in)
      const back = document.createElement('span');
      back.className = [
        'pointer-events-none','absolute','inset-0',
        'flex','items-center','justify-center','whitespace-nowrap',
        'transition-all','duration-300','ease-out',
        'opacity-0','translate-y-full',
        'group-hover/linkfx:opacity-100','group-hover/linkfx:translate-y-0'
      ].join(' ');
      back.setAttribute('aria-hidden','true');
      back.innerHTML = original;

      el.innerHTML = '';
      el.appendChild(front);
      el.appendChild(back);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initLinkEffects(document));
  } else {
    initLinkEffects(document);
  }
})();
